import script from "./TressProductListings.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressProductListings.vue?vue&type=script&lang=ts&setup=true"

import "./TressProductListings.vue?vue&type=style&index=0&id=1b9a2f6d&lang=scss"

const __exports__ = script;

export default __exports__